<div class="vouchers-slider-wrapper">
  @if (voucherList?.length) {
    <h3 class="block-title">{{ "store-payment.Available_vouchers" | translate }}</h3>
    <swiper [config]="sliderOptions">
      @for (voucher of vouchers; track voucher.id) {
          <ng-template swiperSlide>
      <div class="vouchers-slide" [class.used-voucher]="voucher.isUsed"
      [class.voucher-slide-full]="voucher?.isSelected === false">
        <span class="sub-title">-{{ voucher.discount_percentage }}% {{
          voucher?.supplier?.toLowerCase() !==
                "general" ? voucher?.supplier?.toUpperCase() : "" }}</span>
              <p class="amount">{{ voucher?.changeExpiryText ? ("store-payment.Expires" | translate) :
          ("store-payment.Expires_in" | translate) }}
          <app-count-down-timer class="remaining-time" [end]="voucher?.expiry_date?.seconds" type="seconds">
          </app-count-down-timer>
              </p>
                <ion-checkbox mode="ios" class="voucher-checkbox" role="checkbox" [checked]="voucher.isSelected"
                  (ionChange)="onSelectVoucher($event, voucher)" [disabled]="voucher.isDisabled"
                  labelPlacement="end" [attr.data-applied-text]="'store-payment.applied' | translate">
                </ion-checkbox>
                <div class="voucher_hand_tap">
                  @if(!isChecked()) {
                  <ng-lottie class="hand_tap_animation"
                    [options]="{ path : '../../../../assets/tap-animation.json' }"></ng-lottie>
                  }
                </div>
            </div>
          </ng-template>
        }
    </swiper>
}@else{
  <ng-template>
    <div class="empty">No vouchers</div>
  </ng-template>
}
</div>
